import { useState } from 'react';
import { ReactComponent as HelpIcon } from '../../../assets/vectors/help.svg';
import Modal from '../Modal/Modal';
import { QuestionMarkProps } from './QuestionMark.types';
import { ModalSizes } from '../Modal/Modal.types';
import '../../../styles/QuestionMark.css';

export default ({ text }: QuestionMarkProps) => {
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <>
      <HelpIcon className="question-mark" onClick={() => setModalOpen(true)} />
      <Modal
        isOpen={isModalOpen}
        setOpen={setModalOpen}
        size={ModalSizes.Small}
        closeOnClickOutside
        className="question-mark__modal">
        <p>{text}</p>
      </Modal>
    </>
  );
};
